import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import MeetAndShare from "./Pages/MeetAndShare";
import Layout from "./Components/Layout";
import DataPrivacyPolicy from "./Pages/DataPrivacyPolicy";
import EULA from "./Pages/EULA";
import DigitalLibrary from "./Pages/DigitalLibrary";
import FAQ from "./Pages/FAQ";

function App() {
  return (
    <div className="App">
      <Layout>
        {/* This component handles the scroll */}
        <Routes>
          <Route path="/" element={<Home />}></Route>
          {/* <Route
            path="/product/:productname"
            element={<NewbosProduct />}
          ></Route> */}
          <Route path="/meet-and-share" element={<MeetAndShare />}></Route>
          <Route
            path="/data-privacy-policy"
            element={<DataPrivacyPolicy />}
          ></Route>
          {/* <Route path="/contactus" element={<ContactUs />}></Route> */}
          <Route path="/end-user-license-agreement" element={<EULA />}></Route>
          <Route path="/digitallibrary" element={<DigitalLibrary />}></Route>
          <Route path="/faq" element={<FAQ />}></Route>
          <Route path="*" element={<Home />}></Route>
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
